export const REFRESH_URL = process.env.REACT_APP_URL_API + '/users/refreshtoken'
export const API_URL = process.env.REACT_APP_URL_API + '/'
